module.exports = __webpack_public_path__ + "img/408.6214298b.jpg";